module.exports = __webpack_public_path__ + "static/media/centerMatTan10.360df195.png";